import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	BoxInfoCardApplication,
	LifeCycleStatus,
	Status,
	IApplicationInformation,
	ReadMore,
	Heading,
} from 'shared/index'
import { NationalityType } from 'shared/constants/countryTypes'
import { UploadIdentification } from './UploadIdentification'

interface ISignSection {
	application: IApplicationInformation
	applicationId: number
	signingLink: string
	success: boolean
	setSuccess: Function
}

const SignSection = ({
	application,
	signingLink,
	success,
	setSuccess,
}: ISignSection) => {
	const { t } = useTranslation()

	return (
		<div className="container my-5">
			{!success && (
				<section id="sign-section-de">
					<Heading title="IDNow" />

					{application?.signingUrls.onlineIdentification.status ===
						Status.SendByPost &&
						application.lifeCycleStatus ===
							LifeCycleStatus.InternalCheck && (
							<BoxInfoCardApplication
								css="post"
								message={t('SendByPostMessage')}
								image="box-image"
							/>
						)}

					{application?.signingUrls.onlineIdentification.status ===
						Status.Signed && (
						<BoxInfoCardApplication
							css="success"
							message={t('ThankYouIdNow')}
							image="box-image"
						/>
					)}

					{application?.signingUrls.onlineIdentification.status !==
						Status.Signed && (
						<>
							<div className="my-4 d-flex justify-content-center">
								{t('IDNowText')}
							</div>
							<div className="d-flex flex-row justify-content-center">
								<a
									className="btn btn-primary my-5"
									href={signingLink}>
									{t('SignButton')}
								</a>
							</div>

							<ReadMore
								children={
									<div className="upload-doc">
										{application.personalInfo
											?.nationalityType ===
										NationalityType.Unknown ? (
											<div className="d-flex justify-content-center">
												{t('ApplicationCompletionMsg')}
											</div>
										) : (
											<UploadIdentification
												application={application!}
												setSuccess={setSuccess}
											/>
										)}
									</div>
								}
								text={{
									open: t('CloseSection'),
									closed: t('IssuesIdNow'),
								}}
								color="#585857"
								collapsedHeight={'0rem'}
							/>
						</>
					)}
				</section>
			)}

			{application?.lifeCycleStatus === LifeCycleStatus.InternalCheck ||
				(success && (
					<BoxInfoCardApplication
						css="success"
						message={t('ThankYouId')}
						image="box-image"
					/>
				))}
		</div>
	)
}

export default SignSection
